import React from 'react';
import styled from 'styled-components';
import { JRCButton, JRCButtonProps } from '../JRCButton/JRCButton';
import { JRCIconButton } from '../JRCIconButton/JRCIconButton';
import { FormattedMessage } from 'react-intl';
import { Colors, Shades } from 'styles/theme';

/**
 * Interface to provide JRCButtonDownloadProps props
 * @member content text stringify to download
 * @member fileName name of download file
 */
export interface JRCButtonDownloadProps extends JRCButtonProps {
    data: object | string;
    isIconButton?: boolean;
    fileName?: string;
    iconColor?: Colors | Shades | 'inherit';
}

const Download = styled.a`
    color: inherit;
    text-decoration: inherit;
`;

/**
 *
 * @param iconName icon name
 * @param {label, action?, color?, variant?} props, @see JRCButtonDropdownProps
 * @returns JSX.Element
 */
export const JRCButtonDownload = ({
    icon = 'icon-download',
    iconColor = 'primary',
    isIconButton = false,
    data,
    fileName = new Date().getTime().toString(),
    ...props
}: JRCButtonDownloadProps) => {
    const [fileDownloadUrl, setFileDownloadUrl] = React.useState<string>('');
    const linkRef = React.useRef<HTMLAnchorElement>(null);

    const exportApp = () => {
        if (data) {
            const contentAsString: string = JSON.stringify(data, null, 2);
            const blob = new Blob([contentAsString], {
                type: typeof data === 'object' ? 'application/json' : 'text/plain',
            });
            const fileUrl: string = URL.createObjectURL(blob);
            setFileDownloadUrl(fileUrl);
            setTimeout(() => linkRef?.current?.click(), 0);
        }
    };

    return (
        <React.Fragment>
            {isIconButton ? (
                <JRCIconButton onClick={exportApp} icon={icon} color={iconColor} />
            ) : (
                <JRCButton onClick={exportApp} icon={icon} {...props}>
                    {props.children || <FormattedMessage id="GLOBAL_Download" />}
                </JRCButton>
            )}
            <Download ref={linkRef} download={`${fileName}.txt`} href={fileDownloadUrl} />
        </React.Fragment>
    );
};
